import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "searchButton",
    "searchCloseButton",
    "header",
    "searchForm"
  ];

  connect() {
  }

  toggle() {
    this.searchButtonTarget.classList.toggle("is-hidden");
    this.searchCloseButtonTarget.classList.toggle("is-hidden");
    this.headerTarget.classList.toggle("is-hidden");
    this.searchFormTarget.classList.toggle("is-hidden");
  }
}
